<template>
  <component :is="layoutComponent">
    <!-- 仅缓存 meta.keepAlive 为 true 的组件 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 非缓存组件直接渲染 -->
    <router-view v-if="!$route.meta.keepAlive" />
  </component>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DefaultLayout_HeaderBright from "@/layouts/DefaultLayout_HeaderBright.vue";
import DefaultLayout_HeaderFix from "@/layouts/DefaultLayout_HeaderFix.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import mobile_DefaultLayout from "@/layouts/mobile_layouts/DefaultLayout.vue";
import mobile_EmptyLayout from "@/layouts/mobile_layouts/EmptyLayout.vue";

export default {
  name: "App",
    metaInfo() {
        return {
            title: '蓝悦教育 - 专注青少年无人机培训 | 科技特长生培养基地 | 教育部白名单赛事指定机构',
            meta: [
                {
                    name: 'description',
                    content: '蓝悦教育专注6-18岁青少年无人机科技创新教育，提供全学段无人机课程、教育部白名单赛事培训及校区加盟服务。民航局认证资质+西工大产学研合作，助力科技特长生升学。立即咨询课程/加盟政策：029-8928 4201'
                },
                {
                    name: 'keywords',
                    content: '青少年无人机培训， 无人机课程加盟， 教育部白名单赛事， 全国无人机大赛培训，蓝悦教育'
                }
            ]
        }},
  components: {
    DefaultLayout,
    DefaultLayout_HeaderBright,
    DefaultLayout_HeaderFix,
    EmptyLayout,
    mobile_DefaultLayout,
    mobile_EmptyLayout,
  },
  computed: {
    // 判断当前设备是否为手机
    isMobile() {
      return window.innerWidth < 768;
    },
    // 根据设备及路由 meta 信息选择布局组件
    layoutComponent() {
      // 如果layout属性不存在，则使用默认值"default"布局
      const layout = this.$route.meta.layout || "default";
      const headerType = this.$route.meta.headerType;
      // 白底跟随滚动 (多端兼容)
      if (layout === "default") {
        return this.isMobile ? "mobile_DefaultLayout" : "DefaultLayout";
      }
      // 透明跟随滚动--滚动变为白底
      if (layout === "headerbright") {
        return "DefaultLayout_HeaderBright";
      }
      // 白底固定
      if (layout === "headerfix") {
        return "DefaultLayout_HeaderFix";
      }
      // 空布局--无header&footer&toolbar (多端兼容)
      if (layout === "empty") {
        return this.isMobile ? "mobile_EmptyLayout" : "EmptyLayout";
      }
      return this.isMobile ? "mobile_DefaultLayout" : "DefaultLayout";
    },
  },
  mounted() {
    // 监听窗口变化，触发组件更新以便重新计算 isMobile
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 触发重新计算 layoutComponent
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.min-h-screen {
  min-height: 100vh;
}
</style>